// extracted by mini-css-extract-plugin
module.exports = {"header":"ChatHeader_header__2yrof","headerError":"ChatHeader_headerError__1An5z","headerOffline":"ChatHeader_headerOffline__1H1QE","exitButton":"ChatHeader_exitButton__1ALoT"};